import { z } from 'zod';
import { positiveIntSchema } from '../../../shared/index.js';
export const publicSpeakerSignupCreateBodySchema = z
    .object({
    agendaSectionId: positiveIntSchema.optional(),
    agendaSectionLegislativeItemId: positiveIntSchema.optional(),
    name: z.string().trim().min(1, 'Name is required').max(255),
})
    .refine(({ agendaSectionId, agendaSectionLegislativeItemId }) => (agendaSectionId === undefined) !== (agendaSectionLegislativeItemId === undefined), { message: 'Provide exactly one of agendaSectionId or agendaSectionLegislativeItemId' });
